/**
 * Exports all data passed by the server to the window global.
 *
 * All settings should be imported from this file instead of using `window`
 * as it allows for better testing and modularisation.
 */
export const CDN_ROOT = window.CDN_ROOT;
export const IMAGE_ROOT = CDN_ROOT + "static/img/";
export const ICONS_ROOT = CDN_ROOT + "static/icons/";
export const IPRegion = window.IPRegion;
export const ConversionSettings = window.ConversionSettings;
export const ConversionTesting = window.ConversionTesting;
export const DisableGatekeeper = window.DisableGatekeeper;
/** Dream Agility ref code. */
export const daReferenceCode = window.daReferenceCode;
export const dataLayer = window.dataLayer;
/** The country code of the current page. */
export const PageRegion = window.PageRegion;
/** The URLs to the current page in other countries. */
export const PageRegionalUrls = window.PageRegionalUrls;

// FORMS
export const formSettings = window.FormGlobals;
export const trialFormSettings = window.TrialFormOptions;

export type Breakpoint = "sm" | "md" | "lg" | "xl" | "xxl";
export const breakpoints: Record<Breakpoint, number> = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
};
